import { PlessResponderSub } from '../../../kymw00/pless-responder-sub.service';
import { KYMW0902Model } from '../kymw0902.model';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { DutiesDivPlanGoodsSearchConditionModel } from '../vo/duties-div-plan-goods-search-condition.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 業態別企画商品情報取得
 *
 * @export GetDutiesDivPlanGoodsListService
 * @class GetDutiesDivPlanGoodsListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetDutiesDivPlanGoodsListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW0902Model = new KYMW0902Model;
  private vo: DutiesDivPlanGoodsSearchConditionModel = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetDutiesDivPlanGoodsListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        Rec: {
          parameter: {
            OrderCode: this.vo.orderCode,
            EbaseSpecCode: this.vo.ebaseSpecCode,
            DataType: this.vo.dataType,
            JANCode: this.vo.janCode,
            MakerName: this.vo.makerName,
            TagSearchType: this.vo.tagSearchType,
            GoodsMarkSearchType: this.vo.goodsMarkSearchType,
            OrdrClientCode: this.vo.ordrClientCode,
            OrdrClientKanji: this.vo.ordrClientKanji,
            PayeeClientCode: this.vo.payeeClientCode,
            PayeeClientKanji: this.vo.payeeClientKanji,
            ClassCode: this.vo.classCode,
            MiddleClassCode: this.vo.middleClassCode,
            SmallClassCode: this.vo.smallClassCode,
            RegistDateFrom: this.vo.registDateFrom,
            RegistDateTo: this.vo.registDateTo,
            UpdateDateFrom: this.vo.updateDateFrom,
            UpdateDateTo: this.vo.updateDateTo,
            AdmitStatus: this.vo.admitStatus,
            GoodsDiv: this.vo.goodsDiv,
            BuyerCode: this.vo.buyerCode,
            PageNo: this.vo.pageNo,
            SortKey: this.vo.sortKey,
            OrderKey: this.vo.orderKey,
            DutiesFormWeeklyDiv: this.vo.dutiesFormWeeklyDiv,
            DutiesFormSpotDiv: this.vo.dutiesFormSpotDiv,
            DataKbnFlg: this.vo.dataKbnFlg,
          },
          combination: this.createCombinationPcode().concat(
            this.createCombinationItemCode()
          ).concat(
            // 商品名
            this.vo.guideGoodsNameList.map(guideGoodsName => {
              return {
                parameter: {
                  GuideGoodsName: guideGoodsName
                }
              }
            })
          ).concat(
            // 規格名
            this.vo.guideStandardNameList.map(guideStandardName => {
              return {
                parameter: {
                  GuideStandardName: guideStandardName
                }
              }
            })
          ).concat(
            // タグ
            this.vo.tagIdList.map(tagId => {
              return {
                parameter: {
                  TagId: tagId
                }
              }
            })
          ).concat(
            // 商品マーク
            this.vo.goodsMarkList.map(goodsMark => {
              return {
                parameter: {
                  GoodsMark: goodsMark
                }
              }
            })
          ).concat(
            // 単協コード
            this.vo.coopCodeList.map(coopCode => {
              return {
                parameter: {
                  CoopCode: coopCode
                }
              }
            })
          )
        },
        // 業態区分（デイリー）
        DutiesFormDailyDivList: !PlessViewUtilsSub.isEmptyArray(this.vo.dutiesFormDailyDivList) ? {
          combination: this.vo.dutiesFormDailyDivList.map(dutiesFormDailyDiv => {
            return {
              parameter: {
                DutiesFormDailyDiv: dutiesFormDailyDiv
              }
            }
          })
        } : {}
      }
    });
  }

  private createCombinationPcode(): any[] {
    return PlessViewUtilsSub.isEmpty(this.vo.pcode) && !PlessViewUtilsSub.isEmptyArray(this.vo.pcodeList) ?
      // リスト検索
      this.vo.pcodeList.map(pCode => {
        return {
          parameter: {
            Pcode: pCode
          }
        };
      }) : !PlessViewUtilsSub.isEmpty(this.vo.pcode) ?
        // 通常検索
        [{
          parameter: {
            Pcode: this.vo.pcode
          }
        }] : [];
  }

  private createCombinationItemCode(): any[] {
    return PlessViewUtilsSub.isEmpty(this.vo.itemCode) && !PlessViewUtilsSub.isEmptyArray(this.vo.itemCodeList) ?
      // リスト検索
      this.vo.itemCodeList.map(itemCode => {
        return {
          parameter: {
            ItemCode: itemCode
          }
        };
      }) : !PlessViewUtilsSub.isEmpty(this.vo.itemCode) ?
        // 通常検索
        [{
          parameter: {
            ItemCode: this.vo.itemCode
          }
        }] : [];
  }

  /**
   * API呼び出し
   *
   * @param model 処理に使用するモデル
   * @param vo vo
   * @param successFunc 成功時に実行される処理
   * @memberof GetDutiesDivPlanGoodsListService
   */
  execute(model: KYMW0902Model, vo: DutiesDivPlanGoodsSearchConditionModel = null, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.send('KYMW09getDutiesDivPlanGoodsList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetDutiesDivPlanGoodsListService
   */
  success(data: any): void {
    this.model.setDutiesDivPlanGoodsList(data);
  }
}
